'use strict';
import {Component, Inject, Input, OnInit} from 'ng-metadata/core';
import {EndlessScrollingUtil} from '../nddUtils/endlessScollingUtil.service';
import {ConfigurationUtil} from "../nddUtils/configurationUtil.service";

const he = require('he');

@Component({
    directives: [],
    "selector": "prm-copy-clipboard-btn",
    templateUrl: 'components/clipboard/copy-clipboard-btn.html'
})


export class PrmCopyClipboardBtn implements OnInit {

    @Input() public text: string;
	@Input() public type: string;
    @Input() private action: string;

    private buttonText;
    private offset: number;
    private DISPLAY_TEXT: string;
    private SAFARI_DISPLAY_TEXT: string;
    private COPIED_TEXT: string;
    private SAFARI_COPIED_TEXT: string;
    private FAILURE_TEXT: string;
    private scrollContainer: HTMLElement;
    private copySuccessful = false;


    constructor(@Inject('$timeout') private $timeout: ng.ITimeoutService,
                @Inject('clipboard') private clipboard,
                @Inject('$translate') private $translate,
                private configurationUtil: ConfigurationUtil,
                private endlessScrollingUtil: EndlessScrollingUtil) {
        this.scrollContainer = this.getScrollContainer() as HTMLElement;
    }

    ngOnInit() {
        if (this.action == 'share') {
            this.DISPLAY_TEXT = 'fulldisplay.command.pushto.option.shareCopy';
            this.SAFARI_DISPLAY_TEXT = this.getSelectButtonText();
            this.COPIED_TEXT = 'fulldisplay.command.pushto.option.shareCopied';
            this.SAFARI_COPIED_TEXT = 'nui.' + this.action + '.copy.message';
            this.FAILURE_TEXT = 'nui.' + this.action + '.message.failed';
            this.buttonText = (this.isSupported || this.type != 'style') ? this.DISPLAY_TEXT : this.SAFARI_DISPLAY_TEXT;
        } else {
            this.DISPLAY_TEXT = 'nui.' + this.action + '.button';
            this.SAFARI_DISPLAY_TEXT = this.getSelectButtonText();
            this.COPIED_TEXT = 'nui.' + this.action + '.message.success';
            this.SAFARI_COPIED_TEXT = 'nui.' + this.action + '.copy.message';
            this.FAILURE_TEXT = 'nui.' + this.action + '.message.failed';
            this.buttonText = (this.isSupported || this.type != 'style') ? this.DISPLAY_TEXT : this.SAFARI_DISPLAY_TEXT;
        }
    }

    clipboardSuccess(noHandlig) {
        this.displayTemporaryText(this.isSupported ? this.COPIED_TEXT : this.SAFARI_COPIED_TEXT);
        this.copySuccessful = true;
		if (noHandlig) {
			return;
		}
        this.scrollContainer.scrollTop = this.offset;
        this.endlessScrollingUtil.enableSearchEndlessScrolling();
    }

    clipboardFailure(err) {
        this.displayTemporaryText(this.FAILURE_TEXT);
        console.error("Clipborad error!", err);
        this.scrollContainer.scrollTop = this.offset;
        this.endlessScrollingUtil.enableSearchEndlessScrolling();
    }

    private displayTemporaryText(txt) {
        this.buttonText = txt;
        this.$timeout(() => {
            this.buttonText = this.isSupported ? this.DISPLAY_TEXT : this.SAFARI_DISPLAY_TEXT;
            this.copySuccessful = false;
        }, 8000);
    }

    private setFocusOnElement() {
        let copyBtn;
        if(this.action == 'permalink' || this.action == 'share'){
            copyBtn = document.querySelector('.short-permalink #copy-citation-button') as HTMLElement;
            if (copyBtn == null) {
                copyBtn = document.querySelector('.long-permalink #copy-citation-button') as HTMLElement;
            }
            copyBtn.focus();
        }
        else {
            copyBtn = document.querySelector('#copy-citation-button') as HTMLElement;
            copyBtn.focus();
        }
    }

    private getSelectButtonText() {
        if (this.action == 'permalink') {
            return 'nui.permalink.button.selecturl';

        } else if (this.action === 'share') {
            return 'fulldisplay.command.pushto.option.shareCopied';
        }
        //needs to be citation
        else {
            return 'citation.labels.selecttext';
        }

    }

    get textToCopy() {
        return he.decode(this.text ? String(this.text).replace(/<[^>]+>/gm, '') : '');
    }

    get isSupported() {
		let isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
		return !isSafari;
        //let w = window as any;
        //return !(Object.prototype.toString.call(w.HTMLElement).indexOf('Constructor') > 0); //return false if browse is safari
        //return this.clipboard.supported;
    }

    private saveOffset() { //fixes defects PRM-29471 PRM-28752
        this.endlessScrollingUtil.disableSearchEndlessScrolling();
        this.offset = this.scrollContainer.scrollTop;
        this.$timeout(() => {
            this.setFocusOnElement();
        }, 8100);
    }

    get isSuprima(){
        return this.configurationUtil.isSuprima();
    }

    getScrollContainer() {
        let d = document as any;
        let isIE = false || !!d.documentMode;
        let w = window as any;
        //if chrome or safari or edge get document body
        if ((!!w.chrome && !!w.chrome.webstore) ||
            (Object.prototype.toString.call(w.HTMLElement).indexOf('Constructor') > 0) ||
            (!isIE && !!w.StyleMedia)) {
            return document.body;
        }
        return document.body.parentNode;
    }

    private getAriaLabel() {
        const ariaLabel = this.$translate.instant(this.buttonText);
        return this.action === 'citation' ? ariaLabel + `. ${this.$translate.instant('nui.aria.citation.labels.disclaimer')}` : ariaLabel;
    }
	
	public copyToClip() {
		this.saveOffset();
		try {
			let listener = (e) => {
				e.clipboardData.setData("text/html", this.text);
			    e.clipboardData.setData("text/plain", he.decode(this.text ? String(this.text).replace(/<[^>]+>/gm, '') : ''));
			    e.preventDefault();
			}
			
			document.addEventListener("copy", listener);
			document.execCommand("copy");
			document.removeEventListener("copy", listener);
			this.clipboardSuccess();
        }catch(err){
           this.clipboardFailure(err); 
        }
		
	}
		
}



// WEBPACK FOOTER //
// ./src/main/webapp/components/clipboard/copyClipboardBtn.directive.ts